module.exports = __webpack_public_path__ + "static/media/cws.5b7d5d4f.jpeg";